import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Button, Feedback } from '@treezor/design-system';

import { logout } from '@/store/actions/auth.actions';
import { useRoutepaths } from '@/router/hooks/useRoutePaths';

export default function NoAccessPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const PathRoute = useRoutepaths();

  const handleLogout = () => {
    dispatch(logout());
    navigate(PathRoute.auth.root);
  };

  return (
    <div className="flex flex-col">
      <Feedback
        title={`Access denied`}
        messages={`If you need permissions for this view, please contact your manager so they can update your role.`}
        icon="lock_v1"
        info={
          <>
            Don’t hesitate to browse the{' '}
            <a href="#" target="_blank" className="underline">
              Dashboard documentation
            </a>{' '}
            to learn what this page is all about!
          </>
        }
        action={
          <div className="flex gap-3">
            <Button className="w-13" onClick={() => dispatch(navigate(-2))}>
              Get Back
            </Button>
            <Button className="w-13" onClick={handleLogout}>
              Logout
            </Button>
          </div>
        }
      ></Feedback>
    </div>
  );
}
